import React from "react";

const GlobalButton = ({
  children,
  size = "md",             // sm | md | lg
  color = "primary",        // primary | secondary | success | danger | etc.
  variant = "contained",    // contained | outlined | text
  onClick,
  className = "",
  customStyles = {},
  disabled = false,
  type = "button",
}) => {
  const sizeClass = {
    sm: "py-1 px-3 text-sm",
    md: "py-2 px-4 text-base",
    lg: "py-3 px-5 text-lg",
  };

  const variantClass = {
    contained: `btn btn-${color}`,
    outlined: `btn btn-outline-${color}`,
    text: `btn btn-link text-${color}`,
  };

  return (
    <button
      type={type}
      className={`${variantClass[variant]} ${sizeClass[size]} ${className}`}
      style={customStyles}
      onClick={onClick}
      disabled={disabled}
    >
      {children}
    </button>
  );
};

export default GlobalButton;
